import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesRepairsPage from "../pages/services-repairs/page";
import BookServicePage from "../pages/book-service/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services-repairs",
    element: <ServicesRepairsPage />,
  },
  {
    path: "/book-service",
    element: <BookServicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;